import Keycloak from "keycloak-js";
import {environment} from "../environments/environment";

export const keycloak = new (Keycloak as any)({
    url: environment.keycloakUrl,
    realm: environment.keycloakRealm,
    clientId: environment.keycloakClientId,
});
